{
  "version": 1,
  "asset_id": "6c43950d-a745-42b1-964a-dda479aaf3da",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/6c43950d-a745-42b1-964a-dda479aaf3da/bypass-revision-weight-chart-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/6c43950d-a745-42b1-964a-dda479aaf3da/bypass-revision-weight-chart-800.webp",
  "original_filename": "bypass-revision-weight-chart-800.webp",
  "size": 10718,
  "content_type": "image/webp",
  "created_at": "2026-11-01T23:24:18Z"
}
